module.exports = __webpack_public_path__ + "img/eventlog1.aa4668f0.png";